import { RouteConfig } from "vue-router";
import { safeImport } from "@/utils/SafeImport";

const routes: RouteConfig[] = [
  {
    path: "/users/:user_id",
    name: "user_profile",
    component: safeImport(
      () =>
        import(
          /* webpackChunkName: "route.user.profile" */ "../views/UserProfile.vue"
        )
    ),
    meta: {
      auth: true,
    },
  },
  {
    path: "/users/:user_id/edit",
    name: "user_profile_edit",
    component: safeImport(
      () =>
        import(
          /* webpackChunkName: "route.user.profile.edit" */ "../views/UserProfileEdit.vue"
        )
    ),
    meta: {
      auth: true,
      breadcrumbs: "Edit profile",
    },
  },
  {
    path: "/license-agreement",
    name: "license-agreement",
    component: safeImport(
      () =>
        import(
          /* webpackChunkName: "route.license-agreement" */ "../views/LicenseAgreement.vue"
        )
    ),
    meta: {
      auth: true,
    },
  },
  {
    path: "/onboarding",
    name: "onboarding",
    component: safeImport(
      () =>
        import(
          /* webpackChunkName: "route.onboarding" */ "../views/Onboarding.vue"
        )
    ),
    meta: {
      auth: true,
    },
  },
];

export default routes;
